var _excluded = ["slides", "ratio", "hasArrowsOnMobile", "slideTitle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useRef, useState, useEffect } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import ResizeDetector from "../../../helpers/ResizeDetector";
import { disableAllElementsFocusInWrapper, useFocusWrapper } from "../../../hooks/useFocusWrapper";
import useReactSlickSlider from "../../../hooks/useReactSlickSlider";
var PauseSvg = function PauseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 3a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V3Zm-8 0a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V3Z",
    fill: "#000",
    fillOpacity: ".7"
  }));
};
PauseSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "16",
  fill: "none"
};
var PlaySvg = function PlaySvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.752 1.44 22.26 7.568a.5.5 0 0 1 0 .863l-10.508 6.13A.5.5 0 0 1 11 14.13V1.871a.5.5 0 0 1 .752-.432Z",
    fill: "#000",
    fillOpacity: ".7"
  }));
};
PlaySvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "16",
  fill: "none"
};
import { KeyboardEventKeys } from "../../../typings/types";
import LinkAtm from "../../atoms/LinkAtm";
import TextAtm from "../../atoms/TextAtm";
import { SliderDotWrapper } from "../../molecules/ImageSliderMol/ImageSliderMol.styled";
import { defaultProps } from "./SliderTemplate.props";
import { ArrowButton, ArrowIcon, ArrowsContainer, MediaContainer, StyledCarousel, StyledPlayIcon, StyledSliderDot, TextContainer, Wrapper } from "./SliderTemplate.styled";
function SliderTemplate(_ref) {
  var slides = _ref.slides,
    _ref$ratio = _ref.ratio,
    ratio = _ref$ratio === void 0 ? defaultProps.ratio : _ref$ratio,
    hasArrowsOnMobile = _ref.hasArrowsOnMobile,
    slideTitle = _ref.slideTitle,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var sliderRef = useRef(null);
  var sliderIndicatorsRef = useRef(null);
  var imageRefs = useRef([]);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    biggestImageHeight = _useState2[0],
    setBiggestImageHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentSlideIndex = _useState4[0],
    setCurrentSlideIndex = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPlayed = _useState6[0],
    setIsPlayed = _useState6[1];
  var _useFocusWrapper = useFocusWrapper(),
    focusWrapperRef = _useFocusWrapper.focusWrapperRef,
    isWrapperFocused = _useFocusWrapper.isWrapperFocused,
    handleOnFocusWrapper = _useFocusWrapper.handleOnFocusWrapper,
    handleOnBlurWrapper = _useFocusWrapper.handleOnBlurWrapper;
  var _useReactSlickSlider = useReactSlickSlider(sliderRef, focusWrapperRef, !!isWrapperFocused, slides.length),
    sliderUpdateProps = _useReactSlickSlider.sliderUpdateProps,
    handleSliderAfterChange = _useReactSlickSlider.handleSliderAfterChange;
  var handlePlayButtonClick = function handlePlayButtonClick() {
    if (isPlayed) {
      var _sliderRef$current;
      (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 || _sliderRef$current.slickPause();
      setIsPlayed(false);
    } else {
      var _sliderRef$current2;
      (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 || _sliderRef$current2.slickPlay();
      setIsPlayed(true);
    }
  };
  var playTitle = isPlayed ? slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.pause : slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.play;
  var carouselSettings = {
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: "0",
    wrapAround: true,
    accessibility: false,
    appendDots: function appendDots(dots) {
      return /*#__PURE__*/React.createElement("ul", {
        ref: sliderIndicatorsRef
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(StyledPlayIcon, {
        onClick: handlePlayButtonClick,
        role: "button",
        title: playTitle,
        "aria-label": playTitle
      }, isPlayed ? /*#__PURE__*/React.createElement(PauseSvg, null) : /*#__PURE__*/React.createElement(PlaySvg, null))), dots);
    },
    customPaging: function customPaging(index) {
      var isActive = index === currentSlideIndex;
      var dotTitle = isActive ? slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.active : "".concat(slideTitle !== null && slideTitle !== void 0 && slideTitle.dot ? slideTitle.dot : "", " ").concat(index + 1);
      return /*#__PURE__*/React.createElement(SliderDotWrapper, {
        $isActive: isActive
      }, /*#__PURE__*/React.createElement(StyledSliderDot, {
        title: dotTitle,
        "aria-label": dotTitle
      }));
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ARROW_LEFT) {
      var _sliderRef$current3;
      event.preventDefault();
      (_sliderRef$current3 = sliderRef.current) === null || _sliderRef$current3 === void 0 || _sliderRef$current3.slickPrev();
    } else if (event.key === KeyboardEventKeys.ARROW_RIGHT) {
      var _sliderRef$current4;
      event.preventDefault();
      (_sliderRef$current4 = sliderRef.current) === null || _sliderRef$current4 === void 0 || _sliderRef$current4.slickNext();
    }
  };
  useEffect(function () {
    disableAllElementsFocusInWrapper(sliderIndicatorsRef.current);
  }, []);
  var setBiggestImageHeightValue = function setBiggestImageHeightValue() {
    return setBiggestImageHeight(Math.max.apply(Math, _toConsumableArray(imageRefs.current.map(function (_ref2) {
      var clientHeight = _ref2.clientHeight;
      return clientHeight;
    }))));
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, restProps, {
    ref: focusWrapperRef,
    onFocus: function onFocus() {
      var _sliderRef$current5;
      handleOnFocusWrapper();
      (_sliderRef$current5 = sliderRef.current) === null || _sliderRef$current5 === void 0 || _sliderRef$current5.slickPause();
    },
    onBlur: function onBlur(event) {
      var _sliderRef$current6;
      handleOnBlurWrapper(event);
      (_sliderRef$current6 = sliderRef.current) === null || _sliderRef$current6 === void 0 || _sliderRef$current6.slickPlay();
    },
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/React.createElement(StyledCarousel, _extends({}, carouselSettings, {
    $onColor: onColor,
    ref: sliderRef,
    afterChange: handleSliderAfterChange,
    beforeChange: function beforeChange(_currentIndex, nextIndex) {
      return setCurrentSlideIndex(nextIndex);
    }
  }, sliderUpdateProps), slides.map(function (_ref3, index) {
    var image = _ref3.image,
      title = _ref3.title,
      text = _ref3.text,
      link = _ref3.link;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        className: "focusable-slide-wrapper"
      }, /*#__PURE__*/React.createElement(ResizeDetector, {
        onChange: setBiggestImageHeightValue
      }, /*#__PURE__*/React.createElement(MediaContainer, {
        $ratio: ratio,
        ref: function ref(_ref4) {
          if (_ref4) {
            imageRefs.current[index] = _ref4;
          }
        }
      }, image)), title || text || link ? /*#__PURE__*/React.createElement(TextContainer, {
        $hasArrowsOnMobile: hasArrowsOnMobile
      }, title ? /*#__PURE__*/React.createElement(TextAtm, {
        typography: "big3"
      }, title) : null, text ? /*#__PURE__*/React.createElement(TextAtm, {
        typography: "medium1_s"
      }, text) : null, link ? /*#__PURE__*/React.createElement(LinkAtm, {
        to: link.to,
        href: link.href,
        title: link.title,
        openInNewTab: link.openInNewTab,
        scrollTo: link.scrollTo,
        onClick: link.onClick,
        typography: "small4"
      }, link.text) : null) : null))
    );
  })), /*#__PURE__*/React.createElement(ArrowsContainer, {
    $ratio: ratio,
    $biggestImageHeight: biggestImageHeight,
    $hasArrowsOnMobile: hasArrowsOnMobile
  }, /*#__PURE__*/React.createElement(ArrowButton, {
    $direction: "left",
    $onColor: onColor,
    tabIndex: -1,
    onClick: function onClick() {
      var _sliderRef$current7;
      return (_sliderRef$current7 = sliderRef.current) === null || _sliderRef$current7 === void 0 ? void 0 : _sliderRef$current7.slickPrev();
    },
    title: slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.previous,
    "aria-label": slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.previous
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    $onColor: onColor
  })), /*#__PURE__*/React.createElement(ArrowButton, {
    $direction: "right",
    $onColor: onColor,
    tabIndex: -1,
    onClick: function onClick() {
      var _sliderRef$current8;
      return (_sliderRef$current8 = sliderRef.current) === null || _sliderRef$current8 === void 0 ? void 0 : _sliderRef$current8.slickNext();
    },
    title: slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.next,
    "aria-label": slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.next
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    $onColor: onColor
  }))));
}
export default SliderTemplate;